module.exports = __webpack_public_path__ + "img/report-sample-06@3x.75d7c847.png";